import { memo } from 'react';
import MultipleChoice from './MultipleChoice';
import SingleChoice from './SingleChoice';
import { ChoiceElement } from '../../schema/choice.schema';
import { FormDataValue } from '../../hooks/useFormData';

export interface ChoiceProps {
	element: ChoiceElement;
	onChange: (key: string, value: FormDataValue) => void;
	onValidationChange: (key: string, value: boolean) => void;
}

const Choice = memo((props: ChoiceProps) => {
	const { multiple } = props.element;

	return <>{multiple ? <MultipleChoice {...props} /> : <SingleChoice {...props} />}</>;
});

export default memo(Choice);
